import screenbanner from "./images/banner/1.jpg";
import mobilebanner from "./images/banner/2.jpg"
import location1 from "./images/blog/News/4.jpg";
import location2 from "./images/blog/News/1.jpg";
import location3 from "./images/blog/News/6.jpg"
import newsShape1 from "./images/shapes/news-one-shape-1.png";
import overviewImage from "./images/blog/4.jpg";


export const Bannerdata = {
  mobilebanner: mobilebanner,
  screenbanner: screenbanner,
};
export const OverviewData = {
  overviewImage: overviewImage,
  buttonLabel: "Enquire Now",
  tagline: "Google Leases 5.5 Lakh Sq Ft Office Space in Gurugram",
  description: [
 
      `US tech giant Google has secured a significant 550,000 sq ft of office space in Gurugram,
signing a lease agreement with managed workspace provider Table Space, according to
sources familiar with the deal. This marks one of the largest managed workspace transactions
in India. While the duration and financial terms of the lease were not disclosed, the agreement
also includes an option for Google to lease an additional 200,000 sq ft, potentially bringing the
total leased space to 750,000 sq ft.
   `,
   `Furthermore, reports suggest that Google is in discussions
to lease an entire office tower in the city.
The move is part of Google’s broader strategy to expand its office footprint in India, as the
company has been searching for large office spaces for over a year. The deal with Table Space
was recently finalized, with the company set to join other major tenants in the commercial
complex.In 2022, Google had vacated a 700,000 sq ft office space in a Gurugram complex, which it had
leased in 2020.`
 ,
 ` Other large firms, such as IBM (260,000 sq ft) and Ciena (135,000 sq ft), have
also recently secured space within the same complex.
The demand for Grade A office space in India is being driven by several factors, including the
return-to-office trend among tech companies, the rise of global capability centres (GCCs), and
the expansion of flexible workspace operators. The ongoing growth of unicorn startups and the
continued expansion of Big Tech firms like Google further bolster the office leasing market.`,

`According to Cushman &amp; Wakefield, India’s office space leasing is projected to reach a record
83-85 million sq ft in 2024, marking a 13% increase from the previous high in 2023. India has
emerged as a leader in global office leasing, surpassing markets such as the US and China. By

year-end, India is expected to account for nearly 70% of the total net absorption of office space
in the Asia-Pacific region.`


  ],
  amenities: ["High Demand", "Future-Ready Smart Homes"],
  buttonmessage: "More details",
};

// Latest Update
export const LatestUpdate = {
  tagline: `Related Blogs`,
  shape1: newsShape1,
 data: [
  {
    id: 3,
    image: location3,
    alt: "Prestige Group Invests Rs 462",
    date: "30 Oct",
    tag: "Prestige Group Invests Rs 462 Crore to Acquire 17.45 Acres of Land in Bengaluru",
    title:
    `Prestige Group, a leading name in India’s real estate sector, has acquired a prime 17.45-acre
land parcel in Bengaluru`,
    link: "/news-090125",
    review: 5,
  },
    {
      id: 1,
      image: location1,
      alt: "Google",
      date: "01 Jan",
      tag: "Google Leases 5.5 Lakh Sq Ft Office Space in Gurugram, with Plans for Future Expansion",
      title: `Google has secured a significant 550,000 sq ft of office space in Gurugram. `,
      link: "/news-070125",
      review: 2,
    },
    {
      id: 2,
      image: location2,
      alt: "TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25",
      date: "06 Jan",
      tag: "TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25",
      title: `TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25 TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25`,
      link: "/news-080125",
      review: 3,
    },
   
  ],
};
